import { IIMRChartExtension, IIMRChartExtensionController } from "../chart.controller"

//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

export class BaseChartExtension implements IIMRChartExtension {


    // IIMRChartExtension Implementation

    public get extensionName(): string { return 'BaseChartExtension' }

    public clear(): void { }

    public getChartOptions(): DevExpress.viz.charts.dxChartOptions {
        return {
            scrollingMode: 'all',
            useAggregation: false,
            zoomingMode: 'all',

            argumentAxis: {
                maxValueMargin: 0,
                minValueMargin: 0,
                valueMarginsEnabled: true,

                grid: {
                    visible: true
                },

                tick: {
                    visible: true,
                    length: 10,
                    color: 'blue',
                    width: 2
                },
            },

            commonSeriesSettings: {
                argumentField: "argument",
                ignoreEmptyPoints: true,
                point: {
                    size: 4,
                    hoverStyle: {
                        size: 3
                    }
                }
            },
        }
    }

    public getPieChartOptions(): DevExpress.viz.charts.dxPieChartOptions {
        return null
    }

    public initialize(chartController: IIMRChartExtensionController): JQueryPromise<void> {
        return $.Deferred<void>().resolve().promise()
    }

    public refresh(): JQueryPromise<void> {
        return $.Deferred<void>().resolve().promise()
    }

    // IIMRChartExtension Implementation End
}
